/// <reference path="../entity/contracts/contracts.ts" />

module cr.events {
    export var eventModule = angular.module('cr.event', ["cr.common", "cr.entity", 'ui.router']);
}
